
import { PhotoCard } from "../../components/PhotoCard";
import { Challenge as ChallengeType } from "../../lib/types";

type Props = {
  challenge: ChallengeType;
};

export function ClosedChallengeSection({ challenge }: Props) {
  return (
    <section className="space-y-4 mb-4">
      <h2 className="text-2xl font-bold text-bauhaus-darkgreen font-['Bebas_Neue'] tracking-wide mb-2">
        Challenge Complete
      </h2>
      <p className="text-bauhaus-green text-lg mb-3">
        Today's prompt: {challenge.selectedPrompt?.text}
      </p>
      {challenge.winner && (
        <div className="mb-5">
          <h3 className="text-lg font-semibold mb-2 text-bauhaus-darkgreen">Winner!</h3>
          <PhotoCard
            submission={challenge.winner}
            isVoted={false}
            isWinner={true}
            onVote={() => {}}
          />
        </div>
      )}
      {challenge.submissions.length > 0 && (
        <div>
          <h3 className="text-lg font-semibold mb-2 text-bauhaus-darkgreen">All Submissions</h3>
          <div className="grid grid-cols-2 gap-3">
            {challenge.submissions
              .filter(s => !challenge.winner || s.id !== challenge.winner.id)
              .map(submission => (
                <PhotoCard
                  key={submission.id}
                  submission={submission}
                  isVoted={false}
                  onVote={() => {}}
                />
              ))}
          </div>
        </div>
      )}
    </section>
  );
}
